<template>
  <modal
    name="conteudoVisualEdit"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="false"
    @before-open="prepararFormulario"
  >
    <CloseModal :close="close" />
    <Loading :isActive="loading" />
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="conteudo-form__cabecalho">
          <span class="conteudo-form__local">
            <CIcon :name="local.icon" size="sm" class="mr-1" />
            {{ local.label }}
          </span>
          <span class="conteudo-form__titulo">
            {{ item.id ? "Editando conteúdo" : "Novo conteúdo" }}
          </span>
        </div>
        <CTabs variant="tabs" class="nav-tabs-boxed" :activeTab.sync="abaAtiva">
          <CTab>
            <template #title>
              Informações
              <span v-if="abasComErro.includes(0)" class="conteudo-form__erro-aba"></span>
            </template>
            <StepInformacoes :item="item" :validacao="validation" :logosTipo="logosTipo" />
          </CTab>
          <CTab>
            <template #title>
              Conteúdo
              <span v-if="abasComErro.includes(1)" class="conteudo-form__erro-aba"></span>
            </template>
            <StepConteudo :item="item" :validacao="validation" />
          </CTab>
          <CTab>
            <template #title>
              Aparência
              <span v-if="abasComErro.includes(2)" class="conteudo-form__erro-aba"></span>
            </template>
            <StepAparencia :item="item" :validacao="validation" :logosTipo="logosTipo" />
          </CTab>
          <CTab title="Exibição">
            <StepExibicao :item="item" />
          </CTab>
        </CTabs>
      </div>
    </div>
    <div class="modal-footer-bar">
      <CButton variant="outline" color="secondary" @click="close">
        Cancelar
      </CButton>
      <CButton color="primary" @click="handleSubmit">
        Salvar Alterações
      </CButton>
    </div>
  </modal>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import { post, put } from "@/helpers/apiRequest";
import CloseModal from "@/components/CloseModal";
import Loading from "@/components/Loading.vue";
import StepInformacoes from "../sections/StepInformacoes.vue";
import StepConteudo from "../sections/StepConteudo.vue";
import StepAparencia from "../sections/StepAparencia.vue";
import StepExibicao from "../sections/StepExibicao.vue";
import { getLocalConteudo } from "../helpers/conteudoLabels";
import {
  conteudoTipoNormalizado,
  ehConteudoHtml,
  imagensObrigatorias,
  montarPayload,
  tituloObrigatorio,
} from "../helpers/blocoConteudo";

const Validator = SimpleVueValidation.Validator.create({
  templates: {
    required: "*obrigatório",
  },
});

const ABA_POR_CAMPO = {
  "item.descricao": 0,
  "item.ordem": 0,
  "item.tipo_id": 0,
  "item.titulo": 1,
  "item.imagem": 1,
  "item.imagem_mobile": 1,
  "item.largura": 2,
};

export default {
  name: "ConteudoVisualFormModal",
  props: ["item", "close", "logosTipo"],
  components: {
    CloseModal,
    Loading,
    StepInformacoes,
    StepConteudo,
    StepAparencia,
    StepExibicao,
  },
  data() {
    return {
      loading: false,
      abaAtiva: 0,
    };
  },
  computed: {
    local() {
      return getLocalConteudo(this.item.chave, this.logosTipo);
    },
    abasComErro() {
      return Object.keys(ABA_POR_CAMPO)
        .filter((campo) => this.validation.hasError(campo))
        .map((campo) => ABA_POR_CAMPO[campo]);
    },
  },
  watch: {
    "item.chave"() {
      this.normalizarConteudoTipo();
    },
  },
  validators: {
    "item.descricao": (value) => Validator.value(value).required(),
    "item.ordem": (value) => Validator.value(value).required(),
    "item.tipo_id": (value) => Validator.value(value).required(),
    "item.titulo, item.conteudo_tipo": function (titulo) {
      if (tituloObrigatorio(this.item)) {
        return Validator.value(titulo).required().maxLength(255);
      }

      return Validator.value(titulo);
    },
    "item.imagem, item.conteudo_tipo": function (imagem) {
      if (imagensObrigatorias(this.item)) {
        return Validator.value(imagem).required("A imagem desktop é obrigatória.");
      }

      return Validator.value(imagem);
    },
    "item.imagem_mobile, item.conteudo_tipo": function (imagemMobile) {
      if (imagensObrigatorias(this.item)) {
        return Validator.value(imagemMobile).required("A imagem mobile é obrigatória.");
      }

      return Validator.value(imagemMobile);
    },
  },
  methods: {
    prepararFormulario() {
      this.abaAtiva = 0;
      this.validation.reset();
      this.normalizarConteudoTipo();
    },
    normalizarConteudoTipo() {
      const normalizado = conteudoTipoNormalizado(this.item);

      if (normalizado === this.item.conteudo_tipo) {
        return;
      }

      if (ehConteudoHtml(this.item)) {
        this.$set(this.item, "conteudo", "");
      }

      this.$set(this.item, "conteudo_tipo", normalizado);
    },
    handleSubmit() {
      this.$validate().then((success) => {
        if (!success) {
          this.abaAtiva = Math.min(...this.abasComErro);
          return;
        }

        this.salvar(montarPayload(this.item));
      });
    },
    salvar(payload) {
      this.loading = true;

      const requisicao = payload.id
        ? put(`/admin/site-logos/${payload.id}`, payload)
        : post("/admin/site-logos", payload);

      requisicao
        .then((json) => {
          this.close();
          this.$swal({
            title: "Salvo com sucesso",
            text: json && json.message,
            icon: "success",
          });
        })
        .catch((err) => {
          this.$swal({
            title: payload.id ? "Falha ao atualizar" : "Falha ao cadastrar",
            text: err.message,
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.conteudo-form__cabecalho {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.conteudo-form__local {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 12px;
  background: #eceaf3;
  color: #3a3e81;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.conteudo-form__titulo {
  font-size: 16px;
  font-weight: 600;
  color: #1d2939;
}

.conteudo-form__erro-aba {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-left: 4px;
  border-radius: 50%;
  background: #d92d20;
  vertical-align: middle;
}

.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>
